import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError, } from "rxjs/operators";
import {SnackBarService} from "../../@core/services/snack-bar.service";
import {environment} from "../../../environments/environment";
import {IGetShopItems} from "./interfaces/get-shop-items.interface";
import {IInventoryItemV2} from "./interfaces/inventory-item.interface";


@Injectable({
  providedIn: 'root'
})
export class ShopItemsService {

  constructor(private readonly http: HttpClient,
              private sb: SnackBarService
  ) {
  }

  public getShopItems(body: IGetShopItems): Observable<{ items: IInventoryItemV2[]; count: number }> {
    return this.http.post<{ items: IInventoryItemV2[]; count: number }>(`${environment.GATEWAY_URL}/inventory/get-shop-items`, body)
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)));
  }

  private onHandleError(error: HttpErrorResponse): Observable<any> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of();
  }
}
